import {
  getUserChemicalLibrary,
  getPlantChemicalLibrary,
  updateUserChemicalLibrary,
  updatePlantChemicalLibrary,
} from "../../../network/cipAPI";
import { extractPlantId } from "../../../utils/Utils";
import { store } from "../../../network/networkUtil";
import {
  storeApp,
  storePlantChemicalLibrary,
  storeUserChemicalLibrary,
} from "../../../Store/TemplateStore/template.action";
import createNotification, {
  ERROR_NOTIFICATION,
  SUCCESS_NOTIFICATION,
} from "../../Notifications";

let chemicalLibraryHydrationPromise = null;

export const fetchChemicalLibraryData = async (t, isUserScope) => {
  try {
    let response = null;
    const plantId = extractPlantId();
    if (plantId && !isUserScope) {
      response = await getPlantChemicalLibrary();
    } else {
      response = await getUserChemicalLibrary();
    }

    if (response.status === 200) {
      return response.data || [];
    }

    return [];
  } catch (error) {
    createNotification(
      ERROR_NOTIFICATION,
      t("notificationStrings.somethingWrong"),
      "",
    );
    return [];
  }
};

export const ensureChemicalLibraryHydrated = async (dispatch, t) => {
  if (chemicalLibraryHydrationPromise) {
    return chemicalLibraryHydrationPromise;
  }

  chemicalLibraryHydrationPromise = (async () => {
    const currentApp = store.getState().app;
    const shouldSwitchApp = currentApp === "ca";

    if (shouldSwitchApp) {
      dispatch(storeApp(null));
    }

    try {
      const chemicalData = await fetchChemicalLibraryData(t, false);
      const plantId = extractPlantId();

      dispatch(storePlantChemicalLibrary(chemicalData));
      if (!plantId) {
        dispatch(storeUserChemicalLibrary(chemicalData));
      }
    } finally {
      if (shouldSwitchApp) {
        dispatch(storeApp(currentApp));
      }
      chemicalLibraryHydrationPromise = null;
    }
  })();

  return chemicalLibraryHydrationPromise;
};

export const updateChemicalLibraryData = async (
  chemicalDataForUpdate,
  t,
  isUserScope,
  isMakeDefault = false,
) => {
  try {
    const chemicalPayload = chemicalDataForUpdate.map((item) => {
      return {
        chem_id: item.chem_id,
        price: Number(item.price),
        unit: item.unit,
      };
    });

    const payload = {
      chemicals: chemicalPayload,
    };

    const response =
      isUserScope || isMakeDefault
        ? await updateUserChemicalLibrary(payload)
        : await updatePlantChemicalLibrary(payload);

    const successMessage = isMakeDefault
      ? t("chemicalLibrary.dataSetAsDefaultSuccessfully")
      : t("chemicalLibrary.dataUpdatedSuccessfully");

    createNotification(SUCCESS_NOTIFICATION, successMessage, "");

    return response;
  } catch (error) {
    createNotification(
      ERROR_NOTIFICATION,
      t("notificationStrings.somethingWrong"),
      "",
    );
    return null;
  }
};
